import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const QUICK_LINKS = [
  {
    section: 'Admin & Security',
    items: [
      { label: 'Create User', path: '/master/user/create', icon: 'bi-person-plus', color: 'blue', kbd: 'Alt+U' },
      { label: 'Roles Creation', path: '/master/user/roles', icon: 'bi-shield-check', color: 'indigo' },
    ]
  },
  {
    section: 'Accounts & Billing',
    items: [
      { label: 'Charge Master', path: '/master/charge-master', icon: 'bi-tags', color: 'violet', kbd: 'Alt+C' },
      { label: 'Account Master', path: '/master/account-master', icon: 'bi-journal-text', color: 'green', kbd: 'Alt+A' },
    ]
  },
  {
    section: 'Infra & Pharmacy',
    items: [
      { label: 'Room Master', path: '/master/room', icon: 'bi-door-open', color: 'orange', kbd: 'Alt+R' },
      { label: 'Medicine Master', path: '/master/medicine-form', icon: 'bi-prescription2', color: 'pink', kbd: 'Alt+M' },
    ]
  },
];

const MasterQuickActions = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState('Admin');

  useEffect(() => {
    const name = sessionStorage.getItem('userName') || 'Admin';
    setUserName(name);
  }, []);

  return (
    <div className="mqa-root">
      <div className="mqa-header">
        <div className="mqa-header-icon"><i className="bi bi-lightning-charge-fill"></i></div>
        <span className="mqa-header-text">Quick Settings</span>
      </div>

      <div className="mqa-body">
        {QUICK_LINKS.map((group, gi) => (
          <div className="mqa-group" key={gi}>
            <div className="mqa-section-label">{group.section}</div>
            {group.items.map((item, ii) => (
              <button
                key={ii}
                className={`mqa-card mqa-${item.color}`}
                onClick={() => navigate(item.path)}
              >
                <div className="mqa-icon"><i className={`bi ${item.icon}`}></i></div>
                <span className="mqa-label">{item.label}</span>
                {item.kbd && <span className="mqa-kbd">{item.kbd}</span>}
              </button>
            ))}
          </div>
        ))}

        {/* Status */}
        <div className="mqa-status-card">
          <div className="mqa-section-label" style={{ marginBottom: '10px' }}>System Status</div>
          {[
            { label: 'Database Sync', value: 'Active', valueClass: 'mqa-val-green', dotClass: 'mqa-dot-green' },
            { label: 'API Services', value: 'Online', valueClass: 'mqa-val-green', dotClass: 'mqa-dot-green' },
            { label: 'Logged in as', value: userName, valueClass: 'mqa-val-indigo', dotClass: 'mqa-dot-indigo' },
          ].map((row, i) => (
            <div className="mqa-status-row" key={i}>
              <div className={`mqa-dot ${row.dotClass}`}></div>
              <span className="mqa-status-key">{row.label}</span>
              <span className={`mqa-status-val ${row.valueClass}`}>{row.value}</span>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .mqa-root {
          --mqa-accent: #4f46e5;
          --mqa-accent-dark: #4338ca;
          --mqa-accent-soft: #eef2ff;
          --mqa-accent-border: #c7d2fe;

          display: flex; flex-direction: column;
          height: 100%; background: #fff;
        }

        .mqa-header {
          padding: 14px 16px; border-bottom: 1px solid #f1f5f9;
          display: flex; align-items: center; gap: 8px; flex-shrink: 0;
          background: linear-gradient(180deg, #ffffff 0%, #fafbfc 100%);
        }
        .mqa-header-icon {
          width: 28px; height: 28px; border-radius: 7px;
          background: var(--mqa-accent-soft);
          display: flex; align-items: center; justify-content: center;
          font-size: 13px; color: var(--mqa-accent);
        }
        .mqa-header-text {
          font-size: 11px; font-weight: 800; color: #1e293b;
          text-transform: uppercase; letter-spacing: 0.6px;
        }

        .mqa-body {
          padding: 12px; overflow-y: auto; flex: 1;
          display: flex; flex-direction: column; gap: 16px;
        }
        .mqa-body::-webkit-scrollbar { width: 5px; }
        .mqa-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }

        .mqa-group { display: flex; flex-direction: column; gap: 6px; }
        .mqa-section-label {
          font-size: 10px; font-weight: 800; color: #94a3b8;
          text-transform: uppercase; letter-spacing: 0.6px;
        }

        .mqa-card {
          display: flex; align-items: center; gap: 10px; width: 100%;
          padding: 9px 11px; border-radius: 9px; background: #fff;
          border: 1px solid #f1f5f9; cursor: pointer;
          transition: all 0.2s ease; text-align: left;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
        }
        .mqa-card:hover {
          transform: translateX(-2px);
          box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
          border-color: #e2e8f0;
        }
        .mqa-icon {
          width: 30px; height: 30px; border-radius: 8px;
          display: flex; align-items: center; justify-content: center;
          font-size: 14px; flex-shrink: 0; transition: all 0.2s;
        }
        .mqa-label { font-size: 12.5px; font-weight: 600; color: #475569; flex: 1; }
        .mqa-kbd {
          font-size: 10px; background: #f1f5f9; border: 1px solid #e2e8f0;
          border-radius: 5px; padding: 3px 6px; color: #64748b;
          font-family: 'Consolas', monospace; font-weight: 600;
          white-space: nowrap;
        }

        /* card colors */
        .mqa-blue .mqa-icon { background: #dbeafe; color: #2563eb; }
        .mqa-blue:hover { background: #eff6ff; border-color: #bfdbfe; }
        .mqa-indigo .mqa-icon { background: #e0e7ff; color: #4f46e5; }
        .mqa-indigo:hover { background: #eef2ff; border-color: #c7d2fe; }
        .mqa-violet .mqa-icon { background: #ede9fe; color: #7c3aed; }
        .mqa-violet:hover { background: #f5f3ff; border-color: #ddd6fe; }
        .mqa-green .mqa-icon { background: #dcfce7; color: #16a34a; }
        .mqa-green:hover { background: #f0fdf4; border-color: #bbf7d0; }
        .mqa-orange .mqa-icon { background: #ffedd5; color: #ea580c; }
        .mqa-orange:hover { background: #fff7ed; border-color: #fed7aa; }
        .mqa-pink .mqa-icon { background: #fce7f3; color: #db2777; }
        .mqa-pink:hover { background: #fdf2f8; border-color: #fbcfe8; }

        .mqa-status-card {
          background: #f8fafc; border-radius: 10px; padding: 12px;
          border: 1px solid #f1f5f9;
        }
        .mqa-status-row { display: flex; align-items: center; gap: 8px; margin-bottom: 9px; }
        .mqa-status-row:last-child { margin-bottom: 0; }
        .mqa-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
        .mqa-dot-green {
          background: #22c55e;
          box-shadow: 0 0 0 2px rgba(34,197,94,0.2);
        }
        .mqa-dot-indigo {
          background: #4f46e5;
          box-shadow: 0 0 0 2px rgba(79,70,229,0.2);
        }
        .mqa-status-key { font-size: 11.5px; color: #64748b; font-weight: 500; flex: 1; }
        .mqa-status-val { font-size: 11.5px; font-weight: 700; }
        .mqa-val-green { color: #16a34a; }
        .mqa-val-indigo { color: #4f46e5; }
      `}</style>
    </div>
  );
};

export default MasterQuickActions;